import { Grid, Stack } from "@mui/material";
import { CaseInfoItem } from "@/features/case/components/CaseBasicInfo/CaseInfoItem";
import { Button } from "@/components/elements/Button";
import { TGetJobDto } from "@/api/services/main/job/dtos/get-job.dto";
import { FCC } from "@/types/common";
import { Link } from "react-router-dom";
import { AppRoutes } from "@/routes/config";
import { convertNumberToCommas } from "@/utils/input";
import { findLabelByValue, findLabelsByValue } from "@/utils/object";
import { useEnum } from "@/api/services/global/enum";
import { JobObjectFieldsDetail } from "@/features/job/components/job-detail/JobObjectFieldsDetail";
import { useGetCompanySpecificIndustryList } from "@/api/services/global/master";

type TCaseJobInfoProps = {
  jobInfo: TGetJobDto;
  isSharedView?: boolean;
};

export const CaseJobInfo: FCC<TCaseJobInfoProps> = ({ jobInfo, isSharedView = false }) => {
  const {
    id,
    companySpecificIndustry,
    companySpecificIndustryId,
    companySpecificBusinessClassificationIds,
    workplace,
    workplaceDetail,
    recruitmentNumber,
    selfExpense,
    salaryType,
    jobSalarySummaries,
  } = jobInfo;
  const workAddress = `${workplace} ${workplaceDetail ?? ""}`;
  const { data: salaryTypeOptions } = useEnum("ESalaryType");
  const { isLoading: isLoadingIndustry, getCompanySpecificBusinessClassificationListOptionByCompanySpecificIndustry } =
    useGetCompanySpecificIndustryList();

  const urlJobDetail = AppRoutes.jobDetail.replaceAll(":jobId", String(id));

  const totalAmount = jobSalarySummaries?.[0]?.totalAmount;
  const salary =
    totalAmount !== undefined && totalAmount !== null
      ? `${findLabelByValue(salaryTypeOptions, salaryType)} ${convertNumberToCommas(totalAmount.toString())}円`
      : null;

  const getBusinessClassificationLabels = () => {
    if (!isLoadingIndustry && companySpecificIndustryId) {
      const options = getCompanySpecificBusinessClassificationListOptionByCompanySpecificIndustry(companySpecificIndustryId);
      return findLabelsByValue(options, companySpecificBusinessClassificationIds ?? []);
    }
    return null;
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <CaseInfoItem label="分野" value={companySpecificIndustry?.companySpecificIndustry} />
      </Grid>
      <Grid item xs={6}>
        <CaseInfoItem label="区分" value={getBusinessClassificationLabels()} />
      </Grid>
      <Grid item xs={4}>
        <CaseInfoItem label="総支給額" value={salary} />
      </Grid>
      <Grid item xs={4}>
        <CaseInfoItem label="勤務地" value={workplace} />
      </Grid>
      <Grid item xs={4}>
        <CaseInfoItem label="募集人数" value={recruitmentNumber + "人"} />
      </Grid>
      <Grid item xs={12}>
        <JobObjectFieldsDetail title="本人負担費用" data={selfExpense} />
      </Grid>
      {!isSharedView && (
        <Grid item xs={12}>
          <Stack direction="row" spacing={2} justifyContent={"end"}>
            <Button
              size="sm"
              component={Link}
              // Open job detail in a new tab and deep-link to the section via URL hash.
              // JobDetail maps "#basic-info" → the「基本情報」section and auto-scrolls there on load.
              to={`${urlJobDetail}#basic-info`}
              variant="ghost"
              target="_blank"
              sx={{ width: "102px" }}
              // Prevent the button from taking focus on click (it opens a new tab, so focus would
              // otherwise linger here and keep the focus/active style). Keyboard focus still works.
              onMouseDown={(e) => e.preventDefault()}
            >
              詳細を見る
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
};
